export default "__VITE_ASSET__1hGXfyJ5__"